import React from 'react';
import LoginRegister from '../components/LoginRegister/login_register';

console.log("📥 LoginPage component loaded");
function LoginPage() {
    console.log("💡 Rendering LoginPage");
    return <LoginRegister mode="login" />;
}

export default LoginPage;
